module.exports = __webpack_public_path__ + "static/media/bell.cde7fc1.mp3";